<template>
  <div
    class="input-field"
    :class="{ 'is-invalid': dirty && !!errorMessage }">
    <label :for="`textfield--${name}`" class="input-field__label">
      <span v-if="label" class="input-field__label-text">
        {{ label }}
      </span>
      <span v-if="tooltip" class="input-field__tooltip">
        <p>{{ tooltip }}</p>
      </span>
      <div class="input-field__wrapper">
        <input
          class="input-field__input"
          :class="errorMessage ? 'input-field__input--error' : 'input-field__input--default'"
          :type="type"
          ref="input"
          :id="`${id ? id : 'textfield--' + name}`"
          :name="`textfield--${name}`"
          :placeholder="placeholder"
          :tooltip="tooltip"
          :value="value"
          :maxLength="maxLength"
          :max="max"
          :min="min"
          :dirty="dirty"
          :disabled="disabled"
          :autocomplete="autocomplete"
          @input="$emit('update:value', $event.target.value)"
        />
      </div>
      <small v-if="errorMessage" class="input-field__error-message">
        {{ errorMessage }}
      </small>
    </label>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import IMask from 'imask';

const input = ref(null);

const props = defineProps({
  name: String,
  label: String,
  tooltip: String,
  type: String,
  id: String,
  placeholder: String,
  mask: { String, Number },
  errorMessage: String,
  value: String,
  maxLength: { type: [Number, String], default: '' },
  max: Number,
  min: Number,
  dirty: Boolean,
  disabled: Boolean,
  autocomplete: String,
});

onMounted(() => {
  if (props.mask) {
    IMask(input.value, {
      mask: props.mask,
      pattern: 'C',
      blocks: {
        C: {
          mask: /^.+$/,
        },
      },
    });
  }
  if (props.initialFocus) {
    input.value.focus();
  }
});

defineEmits(['update:value']);
</script>

<style scoped lang="scss">
.input-field {
  &__label-text {
    font-size: 18px;

    @media (min-width: 1281px) {
      font-size: 20px;
    }
  }

  &__input {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border: 2px solid $AC_Offwhite;
    border-radius: 5px;
    background-color: #fafafa;
    font-size: clamp(18px, 24px, 1.5vw);

    @media (min-width: 1281px) {
      height: 60px;
    }

    &:hover,
    &:focus {
      border-color: $AC_Orange;
    }

    &:focus {
      outline-offset: 3px;
    }
  }

  &.is-invalid {
    .input-field__input {
      border-color: $AC_Primary;
    }
  }

  &__error-message {
    font-size: clamp(14px, 18px, 1.25vw);
    color: $AC_Primary;
  }
}

.youtube-input {
  .input-field__label-text {
    font-size: clamp(16px, 20px, 1.5vw);
    margin-bottom: 15px;
    display: block;
  }
}

// Acura specific styles
.acura {
  .input-field {
    &__label-text,
    &__input {
      font-family: 'Avenir Book';
    }
  }
}

// Honda specific styles
.honda {
  .input-field {
    &__label-text,
    &__input {
      font-family: 'Myriad Pro';
    }
  }
}
</style>
